import { Link } from "react-router-dom";

export default function CookiesPolicy() {
  const openSettings = () => {
    localStorage.removeItem("borrame_cookie_consent");
    window.dispatchEvent(new CustomEvent("borrame:reopen-cookie-banner"));
  };
  return (
    <div className="bg-[#F9F9F8] min-h-screen">
      <article className="max-w-3xl mx-auto px-6 py-16">
        <div className="eyebrow text-red-600 mb-3">Ley 21.719 · Cookies y trazabilidad</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-gray-900 tracking-tight">
          Política de Cookies
        </h1>
        <p className="mt-3 text-sm font-mono text-gray-500">
          Última actualización: 22 de febrero de 2026
        </p>

        <Block title="¿Qué son las cookies?">
          <p>Las cookies son pequeños archivos de texto que un sitio web guarda en tu navegador. Sirven para recordar tus preferencias, mantener tu sesión iniciada y obtener estadísticas anónimas sobre el uso del sitio.</p>
        </Block>

        <Block title="Tipos de cookies que utilizamos">
          <table className="w-full text-sm border-collapse border border-gray-200 my-4">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-200 px-3 py-2 text-left">Tipo</th>
                <th className="border border-gray-200 px-3 py-2 text-left">Finalidad</th>
                <th className="border border-gray-200 px-3 py-2 text-left">Duración</th>
                <th className="border border-gray-200 px-3 py-2 text-left">Consentimiento</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><b>Esenciales</b><br /><code className="text-xs">session, csrf, auth_token</code></td>
                <td className="border border-gray-200 px-3 py-2">Mantener tu sesión, prevenir CSRF, autenticarte.</td>
                <td className="border border-gray-200 px-3 py-2">Sesión / 30 días</td>
                <td className="border border-gray-200 px-3 py-2 text-green-700 font-mono text-xs">No requiere</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><b>Preferencias</b><br /><code className="text-xs">borrame_cookie_consent</code></td>
                <td className="border border-gray-200 px-3 py-2">Recordar tu decisión sobre cookies y configuración del banner.</td>
                <td className="border border-gray-200 px-3 py-2">1 año</td>
                <td className="border border-gray-200 px-3 py-2 text-green-700 font-mono text-xs">No requiere</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><b>Analíticas</b><br /><code className="text-xs">_ga, _ga_*</code></td>
                <td className="border border-gray-200 px-3 py-2">Estadísticas agregadas sobre páginas visitadas y conversión (Google Analytics 4 con IP anonimizada).</td>
                <td className="border border-gray-200 px-3 py-2">Hasta 24 meses</td>
                <td className="border border-gray-200 px-3 py-2 text-amber-700 font-mono text-xs">Sí (opt-in)</td>
              </tr>
              <tr>
                <td className="border border-gray-200 px-3 py-2"><b>Marketing</b></td>
                <td className="border border-gray-200 px-3 py-2">No utilizamos cookies publicitarias ni de retargeting.</td>
                <td className="border border-gray-200 px-3 py-2">—</td>
                <td className="border border-gray-200 px-3 py-2 font-mono text-xs">No aplica</td>
              </tr>
            </tbody>
          </table>
        </Block>

        <Block title="Tu consentimiento, cuándo quieras">
          <p>Conforme al artículo 12 de la Ley 21.719, tu consentimiento debe ser <b>libre, informado, específico, inequívoco y revocable</b>. Por eso:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>Las cookies no esenciales <b>solo se activan después de tu opt-in</b> explícito en el banner.</li>
            <li>Las casillas nunca están pre-marcadas.</li>
            <li>Los botones “Aceptar” y “Rechazar” tienen el mismo tamaño y visibilidad.</li>
            <li>Puedes cambiar tu decisión en cualquier momento desde el botón inferior de esta página.</li>
          </ul>
          <button
            onClick={openSettings}
            className="mt-5 bg-[#0B2447] hover:bg-[#071932] text-white px-5 py-3 font-semibold text-sm"
            data-testid="reopen-cookie-banner"
          >
            Revisar / cambiar mis preferencias de cookies
          </button>
        </Block>

        <Block title="Cookies de terceros">
          <p>Si autorizas las cookies analíticas, se establecerán también cookies provenientes de <b>Google Analytics 4</b>, sujetas a la política de privacidad de Google. Configuramos el servicio con IP anonimizada y deshabilitamos el cruce con datos publicitarios.</p>
        </Block>

        <Block title="Cómo desactivar cookies desde tu navegador">
          <p>Independientemente de tu elección en el banner, todos los navegadores permiten bloquear o eliminar cookies. Considera que desactivar las cookies esenciales puede impedir el funcionamiento del sitio (no podrás iniciar sesión).</p>
          <ul className="list-disc pl-6 space-y-1.5 text-sm">
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noreferrer" className="underline">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/es/kb/proteccion-antirrastreo-mejorada-en-firefox" target="_blank" rel="noreferrer" className="underline">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/es-cl/guide/safari/sfri11471/mac" target="_blank" rel="noreferrer" className="underline">Safari</a></li>
            <li><a href="https://support.microsoft.com/es-es/microsoft-edge" target="_blank" rel="noreferrer" className="underline">Microsoft Edge</a></li>
          </ul>
        </Block>

        <div className="mt-12 pt-6 border-t border-gray-200 text-xs font-mono text-gray-500">
          Documentos relacionados: <Link to="/legal/privacidad" className="underline">Política de Privacidad</Link> · <Link to="/legal/terminos" className="underline">Términos y Condiciones</Link>
        </div>
      </article>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-display text-xl font-bold text-gray-900 border-l-2 border-[#E63946] pl-3 mb-3">{title}</h2>
      <div className="text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}
